export default "__VITE_ASSET__6aTg_wcK__"